import React from "react";
import { happenings } from "../data/mock";

export default function Happenings() {
  return (
    <section id="happenings" className="py-24 md:py-36">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-16 fade-in">
          <div>
            <div className="section-label mb-4">Happenings</div>
            <h2 className="font-display text-5xl md:text-7xl italic font-light text-[var(--mm-cream)] leading-[0.95]">
              What's cooking.
            </h2>
          </div>
          <a href="#menu" className="hidden md:inline-block link-underline text-[var(--mm-accent)] text-xs tracking-[0.28em] uppercase">
            See the Menu
          </a>
        </div>

        <div className="space-y-24">
          {happenings.map((h, i) => (
            <div
              key={h.id}
              className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center fade-in ${
                i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="md:col-span-7 img-hover">
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={h.image} alt={h.title} className="w-full h-full object-cover" />
                </div>
              </div>
              <div className="md:col-span-5">
                <div className="section-label mb-4">{h.subtitle}</div>
                <h3 className="font-display text-4xl md:text-5xl italic font-light text-[var(--mm-cream)] leading-tight mb-6">
                  {h.title}
                </h3>
                <p className="text-[var(--mm-cream-muted)] leading-relaxed mb-8 font-light">
                  {h.description}
                </p>
                <a href="#reservation" className="btn-outline">{h.cta}</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
